import {ChangeDetectorRef, Component, OnInit, ViewChild} from "@angular/core";
import {SafeResourceUrl} from "@angular/platform-browser";
import {
	AssignData,
	AssignEmployeeDialogComponent,
} from "../../shared/dialogs/assign-employee-dialog/assign-employee-dialog.component";
import {ProjectService} from "../../core/services/services/project.service";
import {EmployeeService} from "../../core/services/services/employee.service";
import {EmployeeCapacityService} from "../../core/services/services/employeeCapacity.service";
import {ProjectTotalCapacityService} from "../../core/services/services/project-total-capacity.service";
import {CustomizingService} from "../../core/services/services/customizing.service";
import {HomescreenService} from "../../core/services/services/homescreen.service";
import {TranslatableComponent} from "../../core/models/TranslatableComponent";
import {TranslateService, TranslatePipe} from "@ngx-translate/core";
import Config from "../../core/config/Config";
import {ExtendOrMoveProjectDialogComponent} from "../../shared/dialogs/extend-or-move-project-dialog/extend-or-move-project-dialog.component";
import {CopyAssignmentsDialogComponent} from "../../shared/dialogs/copy-assignments-dialog/copy-assignments-dialog.component";
import {AuthenticationService} from "../../core/services/services/authentication.service";
import {MatDialog} from "@angular/material/dialog";
import {ApplicationUser} from "../../core/models/ApplicationUser";
import {Employee} from "../../core/models/Employee";
import {CustomizingAbsence} from "../../core/models/Enums/CustomizingAbsence";
import {AppEntity, AppEntityAccessType, Permission} from "../../core/models/AppPermissions";
import {DialogEditFavoritesComponent} from "./dialog-edit-favorites/dialog-edit-favorites.component";
import {Favorite} from "../../core/models/Favorite";
import {CdkDragEnter, CdkDropList, CdkDropListGroup, moveItemInArray, CdkDrag} from "@angular/cdk/drag-drop";
import {ViewportRuler} from "@angular/cdk/overlay";
import {SkillDbDialogComponent} from "../../shared/dialogs/skill-db-dialog/skill-db-dialog.component";
import {EmployeeSkill} from "../../core/models/EmployeeSkill";
import {FilesDialogComponent} from "../../shared/dialogs/files-dialog/files-dialog.component";
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import {firstValueFrom} from "rxjs";
import {AssignmentRequestDTO} from "../../core/models/AssignmentRequestDTO";
import MarketUnit from "../../core/config/MarketUnit";
import {PreferencesService} from "../../core/services/services/preferences.service";
import {DivisionService} from "../../core/services/services/division.service";
import {EmployeePermissionService} from "../../core/services/services/employeePermission.service";
import {DataLakeService} from "../../core/services/services/data-lake.service";
import {WorkloadOverviewCategory} from "../../core/models/Enums/WorkloadOverviewCategory";
import {AppearanceService} from "src/app/core/services/services/appearance.service";
import {Project} from "../../core/models/Project";
import {catchError} from "rxjs/operators";
import {UserNotificationService} from "../../core/services/services/userNotification.service";
import {Role} from "src/app/core/models/Role";
import {MatToolbar} from "@angular/material/toolbar";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatSelect} from "@angular/material/select";
import {MatOption} from "@angular/material/core";
import {MatTooltip} from "@angular/material/tooltip";
import {ReactiveFormsModule, FormsModule} from "@angular/forms";
import {MecDataComponent} from "./mec-data/mec-data.component";
import {AssignmentsNotificationDialogComponent} from "../../shared/assignments-notification-dialog/assignments-notification-dialog.component";
import {NgClass, DatePipe} from "@angular/common";
import {RequiresPermissionDirective} from "../../shared/permission/directives/requires-permission.directive";
import {MatCard, MatCardTitle} from "@angular/material/card";
import {MatIcon} from "@angular/material/icon";

@Component({
	selector: "app-homescreen",
	templateUrl: "./homescreen.component.html",
	styleUrls: ["./homescreen.component.scss"],
	imports: [
		MatToolbar,
		MatFormField,
		MatLabel,
		MatSelect,
		MatOption,
		MatTooltip,
		ReactiveFormsModule,
		FormsModule,
		MecDataComponent,
		AssignmentsNotificationDialogComponent,
		CdkDropListGroup,
		NgClass,
		CdkDropList,
		RequiresPermissionDirective,
		CdkDrag,
		RouterLink,
		MatCard,
		MatIcon,
		MatCardTitle,
		TranslatePipe,
		DatePipe,
	],
})
export class HomeScreenComponent extends TranslatableComponent implements OnInit {
	public isAdmin: boolean;
	public isAdminTempOff: boolean;
	public readonly switchableRoles = [
		Role.MEP_ADMIN,
		Role.DIVISION_MANAGER,
		Role.PROJECT_ADMIN,
		Role.MA_SKILL_EDIT,
		Role.MA_SKILL_AND_ASSIGNMENT_EDIT,
		Role.EXTERNAL,
	];
	public selectedAdminRole: Role = Role.MEP_ADMIN;

	@ViewChild(CdkDropListGroup) listGroup: CdkDropListGroup<CdkDropList>;
	@ViewChild(CdkDropList) placeholder: CdkDropList;

	public target: CdkDropList;
	public targetIndex: number;
	public source: CdkDropList;
	public sourceIndex: number;
	public activeContainer;

	user: ApplicationUser;

	userId: number;
	version: string;
	actionPlanFunctionalityEnabled = false;
	customizingEnabledEmployeeProposal = 0;
	applicationUser: ApplicationUser;
	showAbsenceLink = true;
	userFirstName: string;
	businessUnit: string;
	division: string;
	email: string;
	favorites: Favorite[];
	loaded = false;
	profilePicture: SafeResourceUrl;
	releaseNotesLink = Config.releaseNotesLink;
	lastModifiedDate = new Date(document.lastModified);
	isRoleInReadonly = false;
	isCustomerManager = false;
	deactivateMepSkillEditBUs;
	deactivateSkillEdit;
	loading = true;
	cockpitBusinessUnits: string;
	viewCockpit = false;
	isDivisionManager = false;
	canViewCockpit = false;
	selectedCategory: WorkloadOverviewCategory[] = [WorkloadOverviewCategory.OPERATIV];
	departmentManager = false;
	lastImportDate: Date;
	currentMonth: number;
	showNotificationCard = false;
	hasUnreadNotifications = false;
	unreadNotificationCount = 0;
	isExternal = false;

	private isSkillDialogOpening = false;
	private customizingEnableProposalLoaded = false;

	snowflakes = [] as undefined[];

	constructor(
		private matDialog: MatDialog,
		private viewportRuler: ViewportRuler,
		private divisionService: DivisionService,
		private translateService: TranslateService,
		private _projectService: ProjectService,
		private _employeeService: EmployeeService,
		private _employeeCapacityService: EmployeeCapacityService,
		private _projectTotalCapacityService: ProjectTotalCapacityService,
		private customizingService: CustomizingService,
		private homescreenService: HomescreenService,
		public loginService: AuthenticationService,
		private route: ActivatedRoute,
		private router: Router,
		private cdr: ChangeDetectorRef,
		private preferencesService: PreferencesService,
		private employeePermissionService: EmployeePermissionService,
		public dataLakeService: DataLakeService,
		protected appearanceService: AppearanceService,
		private userNotificationService: UserNotificationService,
	) {
		super(translateService, "HomeScreenComponent");
		this.customizingService.enabledProjectEmployeeProposal().then((enabled) => {
			this.customizingEnabledEmployeeProposal = parseInt(enabled);
			this.customizingEnableProposalLoaded = true;
		});
		this.target = null;
		this.source = null;

		firstValueFrom(route.queryParams).then(async (params) => {
			if (params["assignEmployeeData"]) {
				const data = JSON.parse(params["assignEmployeeData"]) as AssignmentRequestDTO;
				await this.router.navigate(["."], {relativeTo: this.route});
				const employee = await firstValueFrom(_employeeService.getEmployeeById(data.employeeId));

				const project: Project = await firstValueFrom(
					_projectService.getProjectById(data.projectId).pipe(
						catchError((err) => {
							return this._projectService.getMinimalProjectById(data.projectId);
						}),
					),
				);

				if (!this.customizingEnableProposalLoaded) {
					this.customizingEnabledEmployeeProposal = parseInt(
						await this.customizingService.enabledProjectEmployeeProposal(),
					);
				}

				this.matDialog.open<AssignEmployeeDialogComponent, AssignData>(AssignEmployeeDialogComponent, {
					disableClose: true,
					width: "1600px",
					data: {
						employee: employee,
						project: project,
						disableProjects: false,
						enabledProposal: this.customizingEnabledEmployeeProposal,
						formData: data,
					},
				});
			}
		});
	}

	deleteSnowflakes() {
		let flakes = document.getElementsByClassName("snow");
		for (let i = 0; i < flakes.length; i++) {
			try {
				flakes[i].outerHTML = "";
				flakes[i].remove();
			} catch (e) {
				break;
			}
		}
		let newFlakes = document.getElementsByClassName("snow").length;
		if (newFlakes > 0) {
			this.deleteSnowflakes();
		}
	}

	async ngOnInit() {
		await this.getUser();
		await this.customizingService
			.getHomescreenCockpit()
			.then((enabled) => (this.cockpitBusinessUnits = enabled))
			.then(() => {
				if (
					this.cockpitBusinessUnits.includes(this.businessUnit) &&
					this.cockpitBusinessUnits !== "" &&
					this.cockpitBusinessUnits !== undefined &&
					this.canView()
				) {
					this.viewCockpit = true;
				}
			});
		this.getNameOfWarFile();
		firstValueFrom(this.loginService.getUserRoles()).then((res) => {
			if (res[0] === "MA_SKILL_EDIT" || res[0] === "MA_SKILL_AND_ASSIGNMENT_EDIT") {
				this.isRoleInReadonly = true;
			}
			if (res[0] === "CUSTOMER_MANAGER") {
				this.isCustomerManager = true;
			}
			this.isExternal = res.includes(Role.EXTERNAL);
			this.selectedAdminRole = this.switchableRoles.find((role) => res.includes(role)) ?? Role.PROJECT_ADMIN;
		});
		this.customizingService
			.isActionPlanFunctionalityEnabled()
			.then((enabled) => (this.actionPlanFunctionalityEnabled = enabled));
		const currentMonth = new Date().getMonth();
		if (
			(currentMonth === 0 || currentMonth === 11) &&
			!AppearanceService.experimentalFeatures.prohibitSnowflakes.signal()
		) {
			this.snowflakes = [].constructor(200);
		}
		this.deactivateMepSkillEditBUs = await this.customizingService.getDeactivateMepSkillEdit();

		this.homescreenService.getFavorites().subscribe((value) => {
			this.favorites = value.sort((a, b) => a.favOrder - b.favOrder);
		});

		this.isAdmin = this.loginService.isMepAdmin();
		this.isAdminTempOff = this.loginService.getIsAdminTempOff();

		await this.loginService.getApplicationUser().then((applicationUser) => (this.applicationUser = applicationUser));
		firstValueFrom(this._employeeService.getFirstName()).then((value) => (this.userFirstName = value));

		if (this.deactivateMepSkillEditBUs.length > 0) {
			let businessUnits = this.deactivateMepSkillEditBUs.split(";");
			for (const bu of businessUnits) {
				if (
					this.applicationUser.employee?.businessUnit &&
					MarketUnit["MarketUnit"][bu].match(this.applicationUser.employee.businessUnit)
				) {
					this.deactivateSkillEdit = true;
					break;
				}
			}
		}

		this.customizingService.getAbsenceSettings().then((absenceSetting) => {
			this.showAbsenceLink = absenceSetting !== CustomizingAbsence.DISABLE_ABSENCES;
		});

		if (this.applicationUser?.employee?.id) {
			await this.checkForUnreadNotifications();
		}
		await this.checkShowNotificationCard();
	}

	switchAdminRole(role: Role) {
		this.loginService.switchAdminRole(role).subscribe({
			next: () => window.location.reload(),
		});
	}

	public itemTrackBy(item) {
		return item.id;
	}

	ngAfterViewInit() {
		const phElement = this.placeholder.element.nativeElement;

		phElement.style.display = "none";
		phElement.parentElement.removeChild(phElement);
	}

	dropListDropped() {
		if (!this.target) {
			return;
		}

		const phElement = this.placeholder.element.nativeElement;
		const parent = phElement.parentElement;

		phElement.style.display = "none";

		parent.removeChild(phElement);
		parent.appendChild(phElement);
		parent.insertBefore(this.source.element.nativeElement, parent.children[this.sourceIndex]);

		this.target = null;
		this.source = null;
		this.activeContainer = null;

		if (this.sourceIndex !== this.targetIndex) {
			moveItemInArray(this.favorites, this.sourceIndex, this.targetIndex);
		}

		let i = 1;
		for (let favorite of this.favorites) {
			favorite.favOrder = i;
			i++;
		}

		this.homescreenService.saveFavorites(this.favorites).subscribe();
	}

	cdkDropListEntered(e: CdkDragEnter) {
		const drag = e.item;
		const drop = e.container;

		if (drop === this.placeholder) {
			return true;
		}

		const phElement = this.placeholder.element.nativeElement;
		const sourceElement = drag.dropContainer.element.nativeElement;
		const dropElement = drop.element.nativeElement;

		const dragIndex = __indexOf(dropElement.parentElement.children, this.source ? phElement : sourceElement);
		const dropIndex = __indexOf(dropElement.parentElement.children, dropElement);

		if (!this.source) {
			this.sourceIndex = dragIndex;
			this.source = drag.dropContainer;

			sourceElement.parentElement.removeChild(sourceElement);
		}

		this.targetIndex = dropIndex;
		this.target = drop;

		phElement.style.display = "";
		dropElement.parentElement.insertBefore(phElement, dropIndex > dragIndex ? dropElement.nextSibling : dropElement);

		requestAnimationFrame(() => {
			this.placeholder._dropListRef.enter(
				drag._dragRef,
				drag.element.nativeElement.offsetLeft,
				drag.element.nativeElement.offsetTop,
			);
		});
	}

	/**
	 * Opens the assignment dialog for all projects
	 */
	async openAssignEmployeeDialog(employee: Employee = undefined): Promise<void> {
		if (!this.customizingEnableProposalLoaded) {
			this.customizingEnabledEmployeeProposal = parseInt(
				await this.customizingService.enabledProjectEmployeeProposal(),
			);
		}

		this.matDialog.open<AssignEmployeeDialogComponent, AssignData>(AssignEmployeeDialogComponent, {
			disableClose: true,
			height: "55rem",
			width: "90rem",
			data: {
				employee: employee,
				disableProjects: false,
				enabledProposal: this.customizingEnabledEmployeeProposal,
			},
		});
	}

	openChangeProjectEndDialog(): void {
		this.matDialog.open(ExtendOrMoveProjectDialogComponent, {
			disableClose: true,
		});
	}

	openCopyAssignmentsDialog() {
		this.matDialog.open(CopyAssignmentsDialogComponent, {
			disableClose: true,
			width: "1000px",
		});
	}

	openEditMySkills() {
		if (!this.isSkillDialogOpening) {
			this.isSkillDialogOpening = true;
			this.loginService.getApplicationUser().then((user: ApplicationUser) => {
				let currentUser = user.employee;
				if (currentUser != null) {
					this._employeeService.getEmployeeSkillsById(currentUser.id).subscribe((currentUserSkills: EmployeeSkill[]) =>
						SkillDbDialogComponent.openEditSkillsDialog(
							this.matDialog,
							false,
							() => {
								this.isSkillDialogOpening = false;
							},
							currentUserSkills,
							currentUser,
						),
					);
				}
			});
		}
	}

	openMyProfileFiles() {
		this.loginService.getApplicationUser().then((user: ApplicationUser) => {
			let currentUser = user.employee;
			this.matDialog.open(FilesDialogComponent, {data: {employee: currentUser}});
		});
	}

	openEdit() {
		this.matDialog
			.open(DialogEditFavoritesComponent, {
				disableClose: true,
				width: "75rem",
				panelClass: "mep-dialog",
				data: {
					isRoleInReadonly: this.isRoleInReadonly,
					isCustomerManager: this.isCustomerManager,
					deactivateSkillEdit: this.deactivateSkillEdit,
				},
			})
			.afterClosed()
			.subscribe(() => {
				this.homescreenService.getFavorites().subscribe((value) => {
					this.favorites = value.sort((a, b) => a.favOrder - b.favOrder);
				});
			});
	}

	private getNameOfWarFile() {
		this.customizingService.getWarFileName().then((version: string) => {
			this.version = version;
		});
	}

	private async getUser() {
		const user: ApplicationUser = await this.loginService.getApplicationUser();
		let currentUser = user.employee;

		if (currentUser) {
			this.businessUnit = user.employee.businessUnit;
			this.division = await this.divisionService.getDivisionLabel(user.employee.division);

			this.userId = user.employee.id;
			this.email = currentUser.email;
			this.profilePicture = Config.userPhoto + this.email;

			this.user = user;
		}
	}

	private canView() {
		return (
			this.loginService.isMepAdmin() ||
			this.loginService.isBusinessUnitManager() ||
			this.loginService.isExecutive() ||
			this.loginService.isDivisionManager() ||
			this.loginService.isDepartmentManager()
		);
	}

	private async checkForUnreadNotifications(): Promise<void> {
		const notifications = await firstValueFrom(
			this.userNotificationService.getNotificationByUserId(this.applicationUser.employee.id),
		);
		const unreadNotifications = notifications.filter((notification) => !notification.read);

		this.unreadNotificationCount = unreadNotifications.length;
		this.hasUnreadNotifications = this.unreadNotificationCount > 0;
	}

	private async checkShowNotificationCard(): Promise<void> {
		try {
			const hasNotificationPermission = await this.loginService.hasPermission(
				Permission.TRUE,
				AppEntityAccessType.READ,
				AppEntity.NOTIFICATION,
			);

			this.showNotificationCard = this.applicationUser && hasNotificationPermission && !this.viewCockpit;
		} catch (error) {
			console.warn("Fehler beim Prüfen der Notification-Card-Berechtigung:", error);
			this.showNotificationCard = false;
		}
	}
}

function __indexOf(collection, node) {
	return Array.prototype.indexOf.call(collection, node);
}
